module.exports = __webpack_public_path__ + "components/gallery-photo-upload/static/icon-upload-c8e3377b97a0e49d84b51d29c1e1876d.svg";